export const EDUCATION_MODULE_ID = "90024";
export const QUALIFICATION_MODULE_ID = "90056";
